import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IGetPunchCardsParams,
  IPunchCard,
  IPutPunchCardParams,
  IPostPunchCardParams,
} from '@network/models/punch-card.model'

export class PunchCardsApi {
  constructor(private axios: AxiosService) {}

  getPunchCards = async (params?: IGetPunchCardsParams) => {
    const response = await this.axios.get<IPayload<IPunchCard[]>>(
      Endpoints.getPunchCards,
      params,
    )
    return response
  }

  getPunchCard = async (id: number, params?: IGetPunchCardsParams) => {
    const response = await this.axios.get<IPayload<IPunchCard>>(
      Endpoints.getPunchCard(id),
      params,
    )
    return response
  }

  postPunchCard = async (params: IPostPunchCardParams) => {
    const response = await this.axios.post<IPayload<IPunchCard>>(
      Endpoints.postPunchCard,
      params,
    )
    return response
  }

  putPunchCard = async (id: number, params?: IPutPunchCardParams) => {
    const reponse = await this.axios.put<IPayload<IPunchCard>>(
      Endpoints.putPunchCard(id),
      params,
    )
    return reponse
  }

  deletePunchCard = async (id: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deletePunchCard(id))
    return response
  }
}
